// checkout/utils/address.ts

/**
 * Compares the hash codes of two addresses.
 *
 * The server provides a `hashCode` field for each address. This function
 * checks whether both hash codes exist and are identical, which indicates
 * that the two addresses are the same.
 *
 * @param {string|undefined|null} deliveryHash - Hash code from the delivery address.
 * @param {string|undefined|null} paymentHash - Hash code from the payment address.
 * @returns {boolean} - `true` if both hash codes are present and equal,
 *   otherwise `false`.
 */
export function addressesMatch(deliveryHash?: string | null, paymentHash?: string | null): boolean {
	return !!(deliveryHash && paymentHash && String(deliveryHash) === String(paymentHash));
}
